module.exports = __webpack_public_path__ + "img/markers_default.7211dd9.png";


//////////////////
// WEBPACK FOOTER
// ./public/pages/index/assets/img/markers_default.png
// module id = 171
// module chunks = 0